<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="CarListInfo"
                        :filter_language="['Submit_status','Audit_result','Improve_satus','Audit_result2']"
                        :filter_thousandth="['Bad_qty']"
                        :filter_date="['Happen_time']"
                        :header="tableHeader"
                        :option="tableOption"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        :checkflg="false"
                        ref="singleTable"
                ></wTable>
                <!--<el-table
                        ref="singleTable"
                        :data="dataSet"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Car_Code" :label="$t('getapi[6206]')"  width="120"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Create_date" :label="$t('getapi[6207]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Customer_code" :label="$t('getapi[2610]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Customer_name" :label="$t('getapi[2584]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Department" :label="$t('getapi[6208]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Reply_person" :label="$t('getapi[6209]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Happen_addr" :label="$t('getapi[6210]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Item_code" :label="$t('getapi[6211]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Car_type" :label="$t('getapi[6212]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Problem_Description" :label="$t('getapi[6213]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Bad_qty" :label="$t('getapi[6214]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Happen_time" :label="$t('getapi[3259]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Car_promotor" :label="$t('getapi[6215]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Influence" :label="$t('getapi[6216]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="quanlity_manager" :label="$t('getapi[6217]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Submit_status" :label="$t('getapi[6218]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_result" :label="$t('getapi[6219]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Improve_satus" :label="$t('getapi[6220]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_result2" :label="$t('getapi[2621]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_person2" :label="$t('getapi[1602]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="Audit_date2" :label="$t('getapi[6222]')"></el-table-column>
                </el-table>-->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <table>
                        <tr>
                            <td style="width:60px">{{$t('getapi[6206]')}}</td>
                            <td style="width:150px;">
                                <el-input type="text" size="text" v-model="dataDetail.Car_Code" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px">{{$t('getapi[6212]')}}</td>
                            <td style="width:150px;">
                                <el-select filterable v-model="dataDetail.Car_type" size="mini" :disabled="!btn.txtCarType">
                                    <el-option v-for="item in cararr" :key="item.Name" :label="item.Name"
                                               :value="item.Code"></el-option>
                                </el-select>
                            </td>
                            <td style="width:60px">{{$t('getapi[2610]')}}</td>
                            <td style="width:150px;">
                                <routejump :urlNo="31">
                                <el-input  type="text" v-model="dataDetail.Customer_code"
                                           readonly
                                           size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectcustomercode()"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td style="width:60px">{{$t('getapi[2584]')}}</td>
                            <td style="width:150px;" colspan="3">
                                <el-input type="text" size="text" v-model="dataDetail.Customer_name" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[6211]')}}</td>
                            <td>
                                <routejump :urlNo="5">
                                <el-input  type="text" v-model="dataDetail.Item_code"
                                           readonly
                                           size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectitemcode()"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td>{{$t('getapi[6208]')}}</td>
                            <td>
                                <routejump :urlNo="28">
                                <el-input  type="text" v-model="dataDetail.Department"
                                           readonly
                                           size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectpartment()"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td>{{$t('getapi[6209]')}}</td>
                            <td>
                                <routejump :urlNo="6">
                                <el-input  type="text" v-model="dataDetail.Reply_person"
                                           readonly
                                           size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee(1)"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td>{{$t('getapi[6214]')}}</td>
                            <td>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="dataDetail.Bad_qty" :readonly="!btn.txtBadQty" :class="{'readO':!btn.txtBadQty}"></el-input>
                            </td>
                            <td>{{$t('getapi[6217]')}}</td>
                            <td>
                                <routejump :urlNo="6">
                                <el-input  type="text" v-model="dataDetail.Quanlity_Manager"
                                           readonly
                                           size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee(2)"></i>
                                </el-input>
                                </routejump>
                            </td>
                        </tr>
                        <tr>
                            <td rowspan="3">{{$t('getapi[6213]')}}</td>
                            <td colspan="5" rowspan="3">
                                <el-input type="textarea" :row="3" v-model="dataDetail.Problem_Description" :readonly="!btn.txtProblem_Description" :class="{'readO':!btn.txtProblem_Description}"></el-input>
                            </td>
                            <td>{{$t('getapi[3259]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Happen_time" type="date" size="mini"
                                                style="width:100%" :readonly="!btn.dtHappen_time" :class="{'readO':!btn.dtHappen_time}"></el-date-picker>
                            </td>
                            <td>{{$t('getapi[6223]')}}</td>
                            <td>
                                <el-input type="text" v-model="dataDetail.Mrb_No" :readonly="!btn.txtmrb_no" :class="{'readO':!btn.txtmrb_no}"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[6210]')}}</td>
                            <td>
                                <el-input type="text" v-model="dataDetail.Happen_addr" :readonly="!btn.txtHappen_addr" :class="{'readO':!btn.txtHappen_addr}"></el-input>
                            </td>
                            <td>{{$t('getapi[6224]')}}</td>
                            <td>
                                <el-input type="text" v-model="dataDetail.Complaint_No" :readonly="!btn.txtcomplaint_no" :class="{'readO':!btn.txtcomplaint_no}"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[409]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Create_date" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{$t('getapi[6215]')}}</td>
                            <td>
                                <el-input type="text" v-model="dataDetail.Car_promotor" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td rowspan="2">{{$t('getapi[6216]')}}</td>
                            <td colspan="5" rowspan="2">
                                <el-input type="textarea" :row="2" v-model="dataDetail.Influence" :readonly="!btn.txtInfluence" :class="{'readO':!btn.txtInfluence}"></el-input>
                            </td>
                            <td>{{$t('getapi[1210]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Modify_Time" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{$t('getapi[733]')}}</td>
                            <td>
                                <el-input type="text" v-model="dataDetail.Modify_Person" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[6218]')}}</td>
                            <td>
                                <el-input type="text" :value="expsubmit(dataDetail.Submit_status)" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>
                                <el-button type="primary" size="mini" @click="upload4">{{$t('getapi[6225]')}}</el-button>
                            </td>
                            <td>
                                <el-button type="primary" size="mini" @click="submitCarYes" :disabled="!btn.btnOK1" v-if="dataDetail.Submit_status == 0">{{$t('getapi[2051]')}}</el-button>
                                <el-button type="primary" size="mini" @click="submitCarNo" :disabled="!btn.btnOK1" v-if="dataDetail.Submit_status != 0">{{$t('getapi[6226]')}}</el-button>
                            </td>
                        </tr>
                        <tr>
                            <td><i class="el-icon-s-promotion"></i></td>
                            <td>{{$t('getapi[6227]')}}</td>
                            <td>{{$t('getapi[6219]')}}</td>
                            <td>
                                <el-input type="text" :value="expresult(dataDetail.Audit_result)" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{$t('getapi[550]')}}</td>
                            <td>
                                <el-input type="text" v-model="dataDetail.Audit_person" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{$t('getapi[742]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Audit_date" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>
                                <el-button type="primary" size="mini" @click="managerAuditYes" :disabled="!btn.btnYes1">{{$t('getapi[6187]')}}</el-button>
                            </td>
                            <td>
                                <el-button type="primary" size="mini" @click="managerAuditNo" :disabled="!btn.btnNo1">{{$t('getapi[6228]')}}</el-button>
                                <el-button type="primary" size="mini" @click="showRejectReason(0)">{{$t('getapi[8127]')}}</el-button>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="8">

                            </td>
                            <td>{{$t('getapi[6246]')}}</td>
                            <td>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="dataDetail.Reject_count1" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><i class="el-icon-s-promotion"></i></td>
                            <td>{{ $t('getapi[6229]')}}</td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[6230]')}}</td>
                            <td colspan="5">
                                <el-input type="textarea" :row="1" v-model="dataDetail.Problem_Analysis" :readonly="!btn.txtProblem_Analysis" :class="{'readO':!btn.txtProblem_Analysis}"></el-input>
                            </td>
                            <td>{{$t('getapi[6170]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Analysis_Confirm_date" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>
                                <el-button type="primary" size="mini" @click="problemAnalysis" :disabled="!btn.btnOK2">{{$t('getapi[2051]')}}</el-button>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[6231]')}}</td>
                            <td colspan="5">
                                <el-input type="textarea" :row="1" v-model="dataDetail.Correct_Measures" :readonly="!btn.txtCorrect_Measures" :class="{'readO':!btn.txtCorrect_Measures}"></el-input>
                            </td>
                            <td>{{$t('getapi[6170]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Correct_Confirm_date" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>
                                <el-button type="primary" size="mini" @click="correctMeasures" :disabled="!btn.btnOK3">{{$t('getapi[2051]')}}</el-button>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[6232]')}}</td>
                            <td>
                                <el-input type="text" v-model="dataDetail.Recovery_date" :readonly="true" class="readO"></el-input>
                            </td>
                            <td colspan="6">
                                {{$t('getapi[6233]')}}
                            </td>
                            <td>
                                <el-input type="text" v-model="dataDetail.Reply_person_supper" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[6235]')}}</td>
                            <td colspan="7">
                                <el-checkbox v-model="dataDetail.Submission_Type0" true-label="1" false-label="0" :disabled="!btn.chkSubmission_Type0" @change="init">{{$t('getapi[6236]')}}</el-checkbox>
                                <el-checkbox v-model="dataDetail.Submission_Type1" true-label="1" false-label="0" :disabled="!btn.chkSubmission_Type1" @change="init">{{$t('getapi[6237]')}}</el-checkbox>
                                <el-checkbox v-model="dataDetail.Submission_Type2" true-label="1" false-label="0" :disabled="!btn.chkSubmission_Type2" @change="init">{{$t('getapi[6238]')}}</el-checkbox>
                                <el-checkbox v-model="dataDetail.Submission_Type3" true-label="1" false-label="0" :disabled="!btn.chkSubmission_Type3" @change="init">{{$t('getapi[6239]')}}</el-checkbox>
                                <el-checkbox v-model="dataDetail.Submission_Type4" true-label="1" false-label="0" :disabled="!btn.chkSubmission_Type4" @change="init">{{$t('getapi[6240]')}}</el-checkbox>
                            </td>
                            <td>
                                <el-button type="primary" size="mini" @click="upload5">{{$t('getapi[6225]')}}</el-button>
                            </td>
                            <td>
                                <el-button type="primary" size="mini" @click="submissionTypeAuditYes" :disabled="!btn.btnOK4">{{$t('getapi[2051]')}}</el-button>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2"></td>
                            <td colspan="6">
                                <el-checkbox v-model="dataDetail.Submission_Type5" true-label="1" false-label="0" :disabled="!btn.chkSubmission_Type5" @change="init">{{$t('getapi[6241]')}}</el-checkbox>
                                <el-checkbox v-model="dataDetail.Submission_Type6" true-label="1" false-label="0" :disabled="!btn.chkSubmission_Type6" @change="init">{{$t('getapi[6242]')}}</el-checkbox>
                                <el-checkbox v-model="dataDetail.Submission_Type7" true-label="1" false-label="0" :disabled="!btn.chkSubmission_Type7" @change="init">{{$t('getapi[224]')}}</el-checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td>{{$t('getapi[6243]')}}</td>
                            <td>
                                <el-input type="text" v-model="dataDetail.Check_date" :readonly="true" class="readO"></el-input>
                            </td>
                            <td colspan="6">
                                {{$t('getapi[6244]')}}
                            </td>
                            <td>{{$t('getapi[6170]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Submission_confirm_date" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                        </tr>
                        <tr>
                            <td><i class="el-icon-s-promotion"></i></td>
                            <td>{{ $t('getapi[6245]')}}</td>
                            <td>{{ $t('getapi[6220]')}}</td>
                            <td colspan="3">
                                <el-input type="text" :value="expimprove(dataDetail.Improve_satus)" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{$t('getapi[6222]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Promotor_Finish_date" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{$t('getapi[6246]')}}</td>
                            <td>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="dataDetail.Reject_count" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2"></td>
                            <td colspan="4">
                                {{$t('getapi[6247]')}}
                            </td>
                            <td>{{$t('getapi[6215]')}}</td>
                            <td>
                                <el-input type="text" v-model="dataDetail.Car_promotor" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>
                                <el-button type="primary" size="mini" @click="promotorAuditYes" :disabled="!btn.btnYes2">{{$t('getapi[6187]')}}</el-button>
                            </td>
                            <td>
                                <el-button type="primary" size="mini" @click="promotorAuditNo" :disabled="!btn.btnNo2">{{$t('getapi[6228]')}}</el-button>
                                <el-button type="primary" size="mini" @click="showRejectReason(1)">{{$t('getapi[8127]')}}</el-button>
                            </td>
                        </tr>
                        <tr>
                            <td><i class="el-icon-s-promotion"></i></td>
                            <td>{{$t('getapi[6248]')}}</td>
                            <td>{{$t('getapi[6221]')}}</td>
                            <td>
                                <el-input type="text" :value="expresult(dataDetail.Audit_result2)" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{$t('getapi[1602]')}}</td>
                            <td>
                                <el-input type="text" v-model="dataDetail.Audit_person2" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{$t('getapi[6222]')}}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Audit_date2" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>
                                <el-button type="primary" size="mini" @click="managerApprovalYes" :disabled="!btn.btnYes3">{{$t('getapi[6187]')}}</el-button>
                            </td>
                            <td>
                                <el-button type="primary" size="mini" @click="managerApprovalNo" :disabled="!btn.btnNo3">{{$t('getapi[6228]')}}</el-button>
                                <el-button type="primary" size="mini" @click="showRejectReason(2)">{{$t('getapi[8127]')}}</el-button>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="8">

                            </td>
                            <td>{{$t('getapi[6246]')}}</td>
                            <td>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="dataDetail.Reject_count2" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                    </table>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="CarListInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6205]')" queryData="CarListInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!--选择客户代码-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pur/Car/GetCustomerInfoPopupList'" @callback="getcustomercode" ref="customer"></selector>
        <!--选择部门-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pur/Car/GetDepartmentInfoPopupList'" @callback="getpartment" ref="partment"></selector>
        <!--选择项目号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pur/Car/GetItemInfoPopupList'" @callback="getitemcode" ref="itemcode"></selector>
        <!--人员-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Pur/Car/GetEmployeeInfoPopupList'" @callback="getemployee" ref="employee"></selector>

        <el-dialog v-dialogDrag :visible.sync="visReject" :title="$t('getapi[8126]')" width="25%" :close-on-click-modal="false">
            <el-input type="textarea" size="mini" v-model="reasonreject"></el-input>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visReject = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmManagerAuditNo()" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visReject2" :title="$t('getapi[8126]')" width="25%" :close-on-click-modal="false">
            <el-input type="textarea" size="mini" v-model="reasonreject"></el-input>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visReject2 = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmPromotorAuditNo()" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visReject3" :title="$t('getapi[8126]')" width="25%" :close-on-click-modal="false">
            <el-input type="textarea" size="mini" v-model="reasonreject"></el-input>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visReject3 = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmManagerApprovalNo()" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visRejectReason" :title="$t('getapi[8126]')" width="25%" :close-on-click-modal="false">
            <el-table
                    :data="dataSetReject"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="500"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column show-overflow-tooltip prop="reject_reason" :label="$t('getapi[8126]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="reject_person" :label="$t('getapi[8128]')" sortable></el-table-column>
                <el-table-column show-overflow-tooltip prop="reject_time" :label="$t('getapi[8129]')" sortable></el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: 'carview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                visPrintType:false,//打印选择弹框
                printflag:'0',
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('carview'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                dataSet1: [], // 主表数据
                loading: false, // 主表加载状态
                dataDetail:{
                },
                currencyname:'', //币种中文名称
                oldDataDetail: '',
                addoredit: 0,
                cararr: [],
                btn: {
                    dtHappen_time: false,
                    txtProblem_Description: false,
                    txtInfluence: false,
                    txtBadQty: false,
                    txtHappen_addr: false,
                    txtmrb_no: false,
                    txtcomplaint_no: false,
                    txtCarType: false,
                    txtProblem_Analysis: false,
                    txtCorrect_Measures: false,
                    chkSubmission_Type0: false,
                    chkSubmission_Type1: false,
                    chkSubmission_Type2: false,
                    chkSubmission_Type3: false,
                    chkSubmission_Type4: false,
                    chkSubmission_Type5: false,
                    chkSubmission_Type6: false,
                    chkSubmission_Type7: false,
                    btnUpload1: false,
                    btnOK1: false,
                    btnYes1: false,
                    btnNo1: false,
                    btnOK2: false,
                    btnOK3: false,
                    btnUpload2: false,
                    btnOK4: false,
                    btnYes2: false,
                    btnNo2: false,
                    btnYes3: false,
                    btnNo3: false,
                },
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                reasonreject: '', //驳回原因
                visReject: false,
                visReject2: false,
                visReject3: false,
                visRejectReason: false,
                dataSetReject: [],
                scrollTop:0,
            };
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('carview', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.cararr = Array.methods.getCarTypeList();
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd()
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('CarListInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6205]"),this.$t("getapi[8513]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if(!this.$limits.menuvisible("plv2", 318, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 479, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    //管理界面
                    if (that.$limits.authority('plv3', 318,1) == 0) {
                        //查询机
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh');
                        }
                    }
                    else if (that.$limits.authority('plv3', 318,1) == 1) {
                        //编辑级
                        if(that.dataDetail.Submit_status == 1){
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        } else{
                            that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                        }
                    }
                    else if (that.$limits.authority('plv3', 318, 1) == 2) {
                        //删除级
                        if(!that.$limits.fnIsEmpty(that.dataDetail.Car_Code)){
                            if(that.$limits.authority('plv4', 207, 1) == 1){
                                that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
                            } else if(that.dataDetail.Submit_status == 0){
                                that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
                            } else{
                                that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                            }
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this
                that.btn.txtBadQty = false
                that.btn.dtHappen_time = false
                that.btn.txtHappen_addr = false
                that.btn.txtProblem_Description = false
                that.btn.txtInfluence = false
                that.btn.txtmrb_no = false
                that.btn.txtcomplaint_no = false
                that.btn.txtCarType = false
                that.btn.btnYes1 = false
                that.btn.btnNo1 = false
                that.btn.btnOK2 = false
                that.btn.btnOK3 = false
                that.btn.btnUpload2 = false
                that.btn.btnOK4 = false
                that.btn.btnYes2 = false
                that.btn.btnNo2 = false
                that.btn.btnYes3 = false
                that.btn.btnNo3 = false
                that.btn.txtProblem_Analysis = false
                that.btn.txtCorrect_Measures = false
                that.btn.chkSubmission_Type0 = false
                that.btn.chkSubmission_Type1 = false
                that.btn.chkSubmission_Type2 = false
                that.btn.chkSubmission_Type3 = false
                that.btn.chkSubmission_Type4 = false
                that.btn.chkSubmission_Type5 = false
                that.btn.chkSubmission_Type6 = false
                that.btn.chkSubmission_Type7 = false
                that.btn.btnUpload1 = false
                that.btn.btnOK1 = false
                switch (that.dataDetail.Submit_status ) {
                    case 0:
                        that.btn.dtHappen_time = true
                        that.btn.txtProblem_Description = true
                        that.btn.txtInfluence = true
                        that.btn.txtBadQty = true
                        that.btn.txtHappen_addr = true
                        that.btn.txtmrb_no = true
                        that.btn.txtcomplaint_no = true
                        that.btn.txtCarType = true
                        that.btn.btnYes1 = false
                        that.btn.btnNo1 = false
                        that.btn.btnOK2 = false
                        that.btn.btnOK3 = false
                        that.btn.btnUpload2 = false
                        that.btn.btnOK4 = false
                        that.btn.btnYes2 = false
                        that.btn.btnNo2 = false
                        that.btn.btnYes3 = false
                        that.btn.btnNo3 = false
                        that.btn.txtProblem_Analysis = false
                        that.btn.txtCorrect_Measures = false
                        that.btn.chkSubmission_Type0 = false
                        that.btn.chkSubmission_Type1 = false
                        that.btn.chkSubmission_Type2 = false
                        that.btn.chkSubmission_Type3 = false
                        that.btn.chkSubmission_Type4 = false
                        that.btn.chkSubmission_Type5 = false
                        that.btn.chkSubmission_Type6 = false
                        that.btn.chkSubmission_Type7 = false
                        that.btn.btnUpload1 = true
                        that.btn.btnOK1 = true
                        break
                    case 1:
                        that.btn.btnOK1 = true
                        //如果当前登陆人是质量经理
                        if(that.user == that.dataDetail.Quanlity_Manager){
                            that.btn.btnYes1 = true
                            that.btn.btnNo1 = true
                        }
                        switch(that.dataDetail.Audit_result){
                            case '1':
                                that.btn.btnOK1 = false
                                that.btn.btnYes1 = false
                                that.btn.btnNo1 = false
                                that.btn.txtProblem_Analysis = true
                                //如果当前登录人是car回复人
                                if(that.user == that.dataDetail.Reply_person){
                                    that.btn.btnOK2 = true
                                }
                                //car回复人已确认
                                if(!that.$limits.fnIsEmpty(that.dataDetail.Analysis_Confirm_date)){
                                    that.btn.btnOK2 = false
                                    that.btn.txtProblem_Analysis = false
                                    that.btn.txtCorrect_Measures = true
                                    //如果当前登录人是car回复人
                                    if(that.user == that.dataDetail.Reply_person){
                                        that.btn.btnOK3 = true
                                    }
                                    //car回复人已确认
                                    if(!that.$limits.fnIsEmpty(that.dataDetail.Correct_Confirm_date)){
                                        that.btn.txtCorrect_Measures = false
                                        that.btn.btnOK3 = false
                                        that.btn.chkSubmission_Type0 = true
                                        that.btn.chkSubmission_Type1 = true
                                        that.btn.chkSubmission_Type2 = true
                                        that.btn.chkSubmission_Type3 = true
                                        that.btn.chkSubmission_Type4 = true
                                        that.btn.chkSubmission_Type5 = true
                                        that.btn.chkSubmission_Type6 = true
                                        that.btn.chkSubmission_Type7 = true
                                        //原来的需求是car回复人的上级(txtReply_person_supper)才能点击，现在是car回复人就能点击
                                        if(that.user == that.dataDetail.Reply_person){
                                            that.btn.btnUpload2 = true
                                            that.btn.btnOK4 = true
                                        }
                                        //改善措施验证提交类型 确认
                                        if(!that.$limits.fnIsEmpty(that.dataDetail.Submission_confirm_date)){
                                            that.btn.chkSubmission_Type0 = false
                                            that.btn.chkSubmission_Type1 = false
                                            that.btn.chkSubmission_Type2 = false
                                            that.btn.chkSubmission_Type3 = false
                                            that.btn.chkSubmission_Type4 = false
                                            that.btn.chkSubmission_Type5 = false
                                            that.btn.chkSubmission_Type6 = false
                                            that.btn.chkSubmission_Type7 = false
                                            that.btn.btnUpload2 = false
                                            that.btn.btnOK4 = false
                                            if(that.user == that.dataDetail.Car_promotor){
                                                that.btn.btnYes2 = true
                                                that.btn.btnNo2 = true
                                            }
                                            //car发起人同意或驳回
                                            if(that.dataDetail.Improve_satus == 1){
                                                that.btn.btnYes2 = false
                                                that.btn.btnNo2 = false
                                                if(that.user == that.dataDetail.Quanlity_Manager){
                                                    that.btn.btnYes3 = true
                                                    that.btn.btnNo3 = true
                                                }
                                                if(that.dataDetail.Audit_result2 == 1){
                                                    that.btn.btnYes3 = false
                                                    that.btn.btnNo3 = false
                                                }
                                            }
                                        }
                                    }
                                }
                                break
                            case '0':
                                that.btn.btnYes1 = true
                                that.btn.btnNo1 = true
                                break
                        }
                    break
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('carview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            selectInfo(tab, event) {
                let that = this;
                that.SelectIndex = tab.name;
                that.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'CarListInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/Pur/Car/MROViewDataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.$nextTick(function(){
                        that.$processdata.initForm(that.SelectIndex)
                    });
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this
                if(that.code == row.Car_Code){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 318, 1)){
                        return
                    }
                    if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.Car_Code
                                that.getDetail(row.Car_Code)
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.Car_Code
                        that.getDetail(row.Car_Code)
                    }
                }, 100);
            },
            // 新增
            add() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                let date = Common.methods.getDate()
                that.addoredit = 0
                that.code = ''
                that.dataDetail = {
                    isadd: 1,
                    Car_Code: '',
                    Create_date: '',
                    Customer_code: '',
                    Customer_name: '',
                    Department: '',
                    Reply_person: '',
                    Happen_addr: '',
                    Item_code: '',
                    Car_type: '',
                    Problem_Description: '',
                    Bad_qty: 0,
                    Happen_time: date,
                    Car_promotor: '',
                    Influence: '',
                    Modify_Person: '',
                    Modify_Time: '',
                    Car_promotor2: '',
                    Quanlity_Manager: '',
                    Mrb_No: '',
                    Complaint_No: '',
                    Audit_result: '',
                    Audit_person: '',
                    Audit_date: '',
                    Problem_Analysis: '',
                    Analysis_Confirm_date: '',
                    Correct_Measures: '',
                    Correct_Confirm_date: '',
                    Submission_Type: '',
                    Submission_confirm_date: '',
                    Improve_satus: '',
                    Promotor_Finish_date: '',
                    Reject_count: 0,
                    Audit_result2: '',
                    Audit_person2: '',
                    Audit_date2: '',
                    Submit_status: 0,
                    Reply_person_supper: '',
                    Recovery_date: '',
                    Check_date: '',
                    Submission_Type0: '0',
                    Submission_Type1: '0',
                    Submission_Type2: '0',
                    Submission_Type3: '0',
                    Submission_Type4: '0',
                    Submission_Type5: '0',
                    Submission_Type6: '0',
                    Submission_Type7: '0',
                }
                // console.log(that.dataDetail)
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.getView();
                            if(that.addoredit == 0){
                                that.confirmAdd()
                            } else {
                                that.getDetail(that.code)
                            }
                        });
                } else {
                    if(that.addoredit == 0){
                        that.getView();
                        that.confirmAdd()
                    } else {
                        that.getView();
                        that.getDetail(that.code)
                    }
                }
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Pur/Car/CarViewExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "CarListInfo",
                    fromname: that.$t('getapi[6205]'),
                    SelectIndex: that.SelectIndex,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                if(that.dataDetail.Budget_Year == '' || that.dataDetail.Budget_Month == '' || that.dataDetail.Budget_Department == ''){
                    that.$message.warning(that.$t('getapi[8714]'))//'年，月，部门不能为空！'
                    return
                }
                that.dataDetail.Submission_Type = that.dataDetail.Submission_Type0 + ';' + that.dataDetail.Submission_Type1 + ';'  + that.dataDetail.Submission_Type2 + ';' + that.dataDetail.Submission_Type3 + ';' + that.dataDetail.Submission_Type4 + ';' + that.dataDetail.Submission_Type5 + ';' + that.dataDetail.Submission_Type6 + ';' + that.dataDetail.Submission_Type7
                let parm = that.dataDetail
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$http.urlpost('/Pur/Car/CarSaveData', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.code = res.UniqueNum
                        that.getDetail(that.code)
                    }
                });
            },
            getDetail(code) {
                let that = this;
                 if (that.$limits.authority('plv3', 318,1) < 1) {
                     return;
                 }
                that.addoredit = 1
                let parm = {
                    Car_Code: code
                }
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Pur/Car/GetCarInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        if(that.dataDetail.Submission_Type != ''){
                            let arr = that.dataDetail.Submission_Type.split(';')
                            console.log(arr)
                            that.dataDetail.Submission_Type0 = arr[0]
                            that.dataDetail.Submission_Type1 = arr[1]
                            that.dataDetail.Submission_Type2 = arr[2]
                            that.dataDetail.Submission_Type3 = arr[3]
                            that.dataDetail.Submission_Type4 = arr[4]
                            that.dataDetail.Submission_Type5 = arr[5]
                            that.dataDetail.Submission_Type6 = arr[6]
                            that.dataDetail.Submission_Type7 = arr[7]
                        } else {
                            that.dataDetail.Submission_Type0 = '0'
                            that.dataDetail.Submission_Type1 = '0'
                            that.dataDetail.Submission_Type2 = '0'
                            that.dataDetail.Submission_Type3 = '0'
                            that.dataDetail.Submission_Type4 = '0'
                            that.dataDetail.Submission_Type5 = '0'
                            that.dataDetail.Submission_Type6 = '0'
                            that.dataDetail.Submission_Type7 = '0'
                        }
                        // console.log(that.dataDetail)
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                        that.btnauthority()
                    }
                    loadingInstance.close()
                });
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        /*
                        let parm = {
                            Car_Code: that.code
                        }
                        */
                        let parm = that.dataDetail
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Pur/Car/DeleteCar', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            selectcustomercode(){
                let that = this;
                that.$refs.customer.clearInput(true);
            },
            getcustomercode(data){
                let that = this
                console.log(data)
                that.dataDetail.Customer_code = data.code
                that.dataDetail.Customer_name = data.name
            },
            selectpartment(){
                let that = this;
                that.$refs.partment.clearInput(true);
            },
            getpartment(data){
                let that = this
                console.log(data)
                that.dataDetail.Department = data.name
            },
            selectitemcode(){
                let that = this;
                that.$refs.itemcode.clearInput(true);
            },
            getitemcode(data){
                let that = this
                console.log(data)
                that.dataDetail.Item_code = data.code
            },
            selectemployee(val){
                let that = this;
                that.employeeType = val
                that.$refs.employee.clearInput(true);
            },
            getemployee(data){
                let that = this
                console.log(data)
                if(that.employeeType == 1){
                    that.dataDetail.Reply_person = data.name
                } else {
                    that.dataDetail.Quanlity_Manager = data.name
                }
            },
            expresult(val){
                if(val == '1'){
                    return '同意'
                } else if(val == '0'){
                    return '驳回'
                } else {
                    return ''
                }
            },
            expimprove(val){
                let that = this
                if(val == '0'){
                    return that.$t('getapi[4047]')//'无效'
                } else if(val == '1'){
                    return that.$t('getapi[4048]')//'有效'
                } else {
                    return ''
                }
            },
            expsubmit(val){
                let that = this
                if(val == '0'){
                    return that.$t('getapi[8918]')//'未提交'
                } else if(val == '1'){
                    return that.$t('getapi[8917]')//'已提交'
                } else{
                    return ''
                }
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 318,1) < 1){
                    return false
                }
                let flag =  that.oldDataDetail != JSON.stringify(that.dataDetail)
                return flag
            },
            //提交确认
            submitCarYes(){
                let that = this
                let parm = that.dataDetail
                that.$http.urlpost('/Pur/Car/SubmitCarYes', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                    }
                });
            },
            //撤销确认
            submitCarNo(){
                let that = this
                let parm = that.dataDetail
                that.$http.urlpost('/Pur/Car/SubmitCarNo', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                    }
                });
            },
            //质量经理同意
            managerAuditYes(){
                let that = this
                let parm = that.dataDetail
                parm.LangType = that.$processdata.getLang()
                that.$http.urlpost('/Pur/Car/QuanlityManagerAuditYes', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                    }
                });
            },
            //质量经理驳回
            managerAuditNo(){
                let that = this;
                that.reasonreject = '';
                that.visReject = true;
            },
            confirmManagerAuditNo(){
                let that = this
                that.dataDetail.Reason = that.reasonreject
                let parm = that.dataDetail
                that.$http.urlpost('/Pur/Car/QuanlityManagerAuditNo', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                        that.visReject = false
                    }
                });
            },
            // 查看驳回原因
            showRejectReason(val){
                let that = this
                if(!that.dataDetail.Car_Code){
                    that.$message.warning(that.$t('getapi[1158]'))//'请先选择数据！'
                    return false
                }
                let parm  = {
                    car_code: that.dataDetail.Car_Code,
                    reject_status: val
                }
                that.$http.urlpost('/Pur/Car/GetRejectReason', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSetReject = res.DataContent
                        that.visRejectReason = true
                    }
                });
            },
            // car回复人问题原因分析确认
            problemAnalysis(){
                let that = this
                let parm = that.dataDetail
                that.$http.urlpost('/Pur/Car/ReplyPersonAuditYesProblemAnalysis', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                    }
                });
            },
            //car回复人【纠正和预防措施】确认
            correctMeasures(){
                let that = this
                let parm = that.dataDetail
                that.$http.urlpost('/Pur/Car/ReplyPersonAuditYesCorrectMeasures', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                    }
                });
            },
            // 【改善措施提交类型】确认
            submissionTypeAuditYes(){
                let that = this
                that.dataDetail.Submission_Type = that.dataDetail.Submission_Type0 + ';' + that.dataDetail.Submission_Type1 + ';'  + that.dataDetail.Submission_Type2 + ';' + that.dataDetail.Submission_Type3 + ';' + that.dataDetail.Submission_Type4 + ';' + that.dataDetail.Submission_Type5 + ';' + that.dataDetail.Submission_Type6 + ';' + that.dataDetail.Submission_Type7
                let parm = that.dataDetail
                that.$http.urlpost('/Pur/Car/SubmissionTypeAuditYes', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                    }
                });
            },
            // car发起人同意
            promotorAuditYes(){
                let that = this
                let parm = that.dataDetail
                that.$http.urlpost('/Pur/Car/CarPromotorAuditYes', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                    }
                });
            },
            // car发起人驳回
            promotorAuditNo(){
                let that = this;
                that.reasonreject = '';
                that.visReject2 = true;
            },
            confirmPromotorAuditNo(){
                let that = this
                that.dataDetail.Reason = that.reasonreject
                let parm = that.dataDetail
                that.$http.urlpost('/Pur/Car/CarPromotorAuditNo', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                        that.visReject2 = false
                    }
                });
            },
            //质量经理批准同意
            managerApprovalYes(){
                let that = this
                let parm = that.dataDetail
                that.$http.urlpost('/Pur/Car/QuanlityManagerApprovalYes', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                    }
                });
            },
            //质量经理批准驳回
            managerApprovalNo(){
                let that = this;
                that.reasonreject = '';
                that.visReject3 = true;
            },
            confirmManagerApprovalNo(){
                let that = this
                that.dataDetail.Reason = that.reasonreject
                let parm = that.dataDetail
                that.$http.urlpost('/Pur/Car/QuanlityManagerApprovalNo', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.code)
                        that.visReject3 = false;
                    }
                });
            },
            upload4(){
                let that = this
                if(that.addoredit == 0){
                    that.$message.warning(that.$t('getapi[8715]'))//'请先保存单据，然后再上传附件！'
                    return
                }
                that.$store.commit('setSharedParams',{
                    Code: that.dataDetail.Car_Code,
                    Data_Type: 4
                });
                let item = {
                    label: '其他文档',
                    name: 'doc',
                    path: '/doc',
                    url: '/doc',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/doc'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            upload5(){
                let that = this
                if(that.addoredit == 0){
                    that.$message.warning(that.$t('getapi[8715]'))//'请先保存单据，然后再上传附件！'
                    return
                }
                that.$store.commit('setSharedParams',{
                    Code: that.dataDetail.Car_Code,
                    Data_Type: 5
                });
                let item = {
                    label: '其他文档',
                    name: 'doc',
                    path: '/doc',
                    url: '/doc',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/doc'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            // 强制重新渲染
            init(){
                let that = this
                that.$forceUpdate()
            }
        }
    };
</script>

<style scoped lang="less">
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .el-textarea {
        display: block;
    }
</style>
